// @flow
import { PrintConfActionTypes } from './constants';

type PrintConfAction = { type: string, payload: {} | string };

// common success
export const printConfApiResponseSuccess = (actionType: string, data: any): PrintConfAction => ({
    type: PrintConfActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const printConfApiResponseError = (actionType: string, error: string): PrintConfAction => ({
    type: PrintConfActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const updatePrintConf = (printConf: any): PrintConfAction => ({
    type: PrintConfActionTypes.UPDATE_PRINT_CONF,
    payload: printConf
})

export const resetPrintConf = (): PrintConfAction => ({
    type: PrintConfActionTypes.RESET,
    payload: {},
});

